/**
 * Matcher for cookies
 * @module
 */

var match = require('core/lib/match');

/**
 * @type ConditionMatcher
 */
module.exports = {
  // specify the fields needed
  fieldsNeeded: [
    'cookies',
  ],

  /**
   * @param {Object} value
   * @param {Object} value.cookies
   * @param {Condition} cond
   * @return {boolean}
   */
  match: function(value, cond) {
    var cookieName = cond.name;
    var valueToMatch = cond.value;
    var matchType = cond.match;
    var cookieValue = value.cookies[cookieName];
    return match.hasMatch(valueToMatch, matchType, cookieValue);
  },
};
